import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type SidebarSectionProps = {
  className?: string;
  children: ReactNode;
};

const SidebarSection = ({ className, children }: SidebarSectionProps) => {
  return (
    <div
      className={cn(
        'container--actionGroup',
        'tw-border-t-[1px] tw-border-t-solid tw-border-t-cfo-grey-500',
        'tw-p-[10px]',
        className
      )}
    >
      {children}
    </div>
  );
};

export default SidebarSection;
